// src/api/reports.api.js
import api from './axios';

// لیست تمام گزارش‌ها (ادمین)
export const getAllReports = () => api.get('/report/reports');

// دریافت گزارش‌های یک کاربر خاص
export const getReportsByUser = (userId) =>
  api.get(`/report/my?userId=${userId}`);

// دریافت فایلهای اتچ یک کاربر خاص
export const getReportsAttachmentsByUser = (userId) =>
  api.get(`/report/attachments?userId=${userId}`);

// ارسال بازخورد کوچ
export const sendCoachFeedback = (reportId, data) =>
  api.post(`/report/${reportId}/feedback`, data);

// دریافت گروه‌های عکس برای یک کاربر
export const getPhotoGroups = (userId) =>
  api.get(`/report/photo-groups?userId=${userId}`);

// آرشیو کردن گزارش
export const archiveReport = (reportId) =>
  api.put(`/report/report/${reportId}`, { archive: true });

// دریافت وزن کاربر
export const getUserWeight = (userId) => api.get(`/report/weight/${userId}`);

// دریافت اندازه‌گیری‌های کاربر
export const getMeasurements = (userId) =>
  api.get(`/report/measurements/${userId}`);

// لیست تمام گزارش‌ها برای ادمین
export const getAllReportsAdmin = () => api.get('/report/admin/all');

// دریافت لیست تمام مشتریان
export const getAllClients = () => api.get('/api/client');

// دریافت بازخورد کوچ برای یک گزارش
export const getFeedback = (reportId) =>
  api.get(`/report/${reportId}/feedback`);

// به‌روزرسانی بازخورد کوچ برای یک گزارش
export const updateCoachFeedback = (reportId, payload) =>
  api.put(`/report/${reportId}/feedback`, payload);

// src/api/reports.api.js
export const createAdminManualReport = (data) =>
  api.post('/report/admin/manual-report', data);

// حذف فایل ضمیمه
export const deleteAttachment = (attachmentId) =>
  api.delete(`/report/attachment/${attachmentId}`);
